import { render, staticRenderFns } from "./otp.pug?vue&type=template&id=5d027d78&lang=pug&"
import script from "./otp.js?vue&type=script&lang=js&"
export * from "./otp.js?vue&type=script&lang=js&"
import style0 from "./otp.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lauramunozruiz/multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d027d78')) {
      api.createRecord('5d027d78', component.options)
    } else {
      api.reload('5d027d78', component.options)
    }
    module.hot.accept("./otp.pug?vue&type=template&id=5d027d78&lang=pug&", function () {
      api.rerender('5d027d78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/otp/index.vue"
export default component.exports